import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  Input,
} from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SuperDynamicComponent } from '../../../helpers/super-dynamic-component';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, ConfirmDialogModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent extends SuperDynamicComponent {
  @Input() confirmationKey?: string;

  constructor(private injector: Injector) {
    super(injector);
  }
}
